import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/projects/$projectId/insights/')({
  beforeLoad: ({ params }) => {
    throw redirect({ to: '/projects/$projectId/insights/flags', params, replace: true });
  },
});
